import { render, staticRenderFns } from "./PlatformCorp.vue?vue&type=template&id=c64d808a&"
import script from "./PlatformCorp.vue?vue&type=script&lang=js&"
export * from "./PlatformCorp.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCorp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports